import dispatcher from '../dispatcher';

var elementProto = Object.create(HTMLLabelElement.prototype);
var idNum = 1;
var idName = 'input-wrapper-';

var _showError = function(type) {
	var text;
	var self = this;

	var coordinates;

	this.classList.add('error');
	this._input.setAttribute('aria-invalid', true);

	// if (type === 'required') {
	// 	text = this._requiredError;
	// } else if (type === 'invalid') {
	// 	text = this._invalidError;
	// }
}

var _handleDispatcher = function(e) {
	var errorType = null;
	var val1, val2;
	var group, groupInputs;
	var groupCheck = false;

	if (e.type === 'form-validate') {
		if (e.id !== this._id) return;

		group = this._input.getAttribute('data-required-group');

		if (this._input.type === 'checkbox') {
			if (this._input.getAttribute('required') !== null) {
				if (!this._input.checked) {
					this._input.value = '0';
					this.classList.add('error');

					errorType = 'required';
				} else {
					this._input.value = '1';
				}
			}
		} else {
			if (this._input.getAttribute('required') !== null) {
				if (!this._input.value) {
					this.classList.add('error');

					errorType = 'required';
				}
			}

			if (group) {
				groupInputs = document.querySelectorAll('input[data-required-group="' + group + '"]');
				groupInputs.forEach(function(input) {
					if (input.value) {
						groupCheck = true;
					}
				});
				if (!groupCheck) {
					errorType = 'required';
				}
			}
		}

		if (errorType) {
			this._form.invalidate();
			this.showError(errorType);
		}
	}
}

var _handleInput = function() {
	var self = this;
	this.classList.remove('error');
	this._input.removeAttribute('aria-invalid');

	if (this._input.value !== '') {
		this.classList.add('not-empty');
	} else {
		this.classList.remove('not-empty');
	}
}

var _handleChange = function() {
	var self = this;
	this.classList.remove('error');
}

var _handleFocus = function() {
	var self = this;
	this.classList.remove('error');
	this.classList.add('focus');
}

var _handleBlur = function() {
	this.classList.remove('focus');
}

elementProto.createdCallback = function() {
	this.handleDispatcher = _handleDispatcher.bind(this);
	this.handleInput = _handleInput.bind(this);
	this.handleFocus = _handleFocus.bind(this);
	this.handleBlur = _handleBlur.bind(this);
	this.handleChange = _handleChange.bind(this);
	this.showError = _showError.bind(this);
}
elementProto.attachedCallback = function() {
	var form;
	this._form = this.closest('form');

	this._input = this.getElementsByTagName('input')[0];
	if (!this._input) {
		this._input = this.getElementsByTagName('textarea')[0];
	}
	if (!this._input) {
		this._input = this.parentNode.getElementsByTagName('input')[0];
	}
	if (!this._input) { // just give up already
		return;
	}

	this._id = this.getAttribute('data-id');
	if (!this._id) {
		form = this.closest('form');
		this._id = form.getAttribute('data-id');
	}

	this._requiredError = this._input.getAttribute('data-required-error');
	this._invalidError = this._input.getAttribute('data-invalid-error');

	if (this._input.type === 'checkbox') {
		this._input.addEventListener('change', this.handleChange);
	} else {
		this._input.addEventListener('input', this.handleInput);
		this._input.addEventListener('change', this.handleInput);
		this._input.addEventListener('focus', this.handleFocus);
		this._input.addEventListener('blur', this.handleBlur);

		this.handleInput();
	}

	this.classList.add('input-ready');

	dispatcher.subscribe(this.handleDispatcher);
}
elementProto.detachedCallback = function() {
	if (!this._input) { // just give up already
		return;
	}

	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('input-wrapper', {
	prototype: elementProto,
	extends: 'label'
});